import React from "react";
import PropTypes from "prop-types";
import Link from "@/components/Link";
import BigMessage from "@/components/BigMessage";
import EmptyState, { EmptyStateHelpMessage } from "@/components/empty-state/EmptyState";
import DynamicComponent from "@/components/DynamicComponent";
import { currentUser } from "@/services/auth";
import HelpTrigger from "@/components/help-trigger/HelpTrigger";

export default function AlertEventsListEmptyState({ page, searchTerm }) {
  if (searchTerm !== "") {
    return <BigMessage message="Sorry, we couldn't find anything." icon="fa-search" />;
  }

  switch (page) {
    case "favorites":
      return <BigMessage message="Mark alert events as Favorite to list them here." icon="fa-star" />;
    case "archive":
      return <BigMessage message="Archived alert events will be listed here." icon="fa-archive" />;
    case "my":
      const myMessage = currentUser.hasPermission("list_alerts") ? (
        <span>
          <Link.Button href="alerts/new" type="primary" size="small">
            Create your first alert!
          </Link.Button>{" "}
          <HelpTrigger className="f-13" type="ALERTS" showTooltip={false}>
            Need help?
          </HelpTrigger>
        </span>
      ) : (
        <span>Sorry, we couldn't find anything.</span>
      );
      return <BigMessage icon="fa-search">{myMessage}</BigMessage>;
    default:
      return (
        <DynamicComponent name="AlertEventsList.EmptyState">
          <EmptyState
            icon="fa fa-bell"
            illustration="alert"
            description="Tracking events from your alerts."
            helpMessage={<EmptyStateHelpMessage helpTriggerType="ALERTS" />}
          />
        </DynamicComponent>
      );
  }
}

AlertEventsListEmptyState.propTypes = {
  page: PropTypes.string.isRequired,
  searchTerm: PropTypes.string.isRequired,
};
